import Cookies from "js-cookie";
import useNewToken from "../services/MainLayout/RefreshToken";
import { useContext } from "react";
import { UserContext } from "src/contexts/UserContext";
import { MenuContext } from "src/contexts/menu-context/MenuContext";
import useAAA from "src/utils/hook/base/useAAA";

const useUserCheck = () => {
  //const { setNewTabItems, setNewTabContent, setTab } = useContext(MenuContext);
  const {setIsLoggedin}=useContext(UserContext)
  const {clearUserData}=useAAA();
  const { NewToken } = useNewToken();
  const loginStatus = () => {
    const CurrentTime = new Date() / 1000-2;
    const CurrentTimeWso2=CurrentTime+Cookies.get("amdehfdmwhjwqlk")
    if (
      Cookies.get("poijwejsmvcsd") === undefined || 
      Cookies.get("pqwlmakxmcer") === undefined ||
      Cookies.get("opwqkmnzxnsdf") === undefined ||
      Cookies.get("nmzbxcbashsaoisd") === undefined
      || Cookies.get("opwqkmnzxnsdf") < CurrentTime
      || Cookies.get("amdehfdmwhjwqlk") < CurrentTimeWso2

    ) {
      clearUserData();
    }
    else{

    if (Cookies.get("poijwejsmvcsd") > CurrentTime) 
      {
        setIsLoggedin(true);
      }
      else{
    

    if (Cookies.get("poijwejsmvcsd") < CurrentTime && Cookies.get("opwqkmnzxnsdf") > CurrentTime )
      {
        NewToken();
      }
      else
      {
      if (Cookies.get("poijwejsmvcsd") < CurrentTime && Cookies.get("opwqkmnzxnsdf") < CurrentTime )
      {
        clearUserData()

      }}
    }
    }

  };

  return { loginStatus };
};
export default useUserCheck;
